var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65656 1.82556C2.1253 1.82556 1.78847 2.23998 1.82955 2.64527C2.64104 10.8396 9.16036 17.3589 17.3547 18.1704C17.76 18.2115 18.1744 17.8747 18.1744 17.3434V14.0947C18.1744 13.7022 17.9234 13.3535 17.55 13.2293L14.3917 12.176C14.064 12.0673 13.7025 12.1522 13.4579 12.3969L12.9522 12.9026C12.3479 13.5068 11.384 13.6228 10.6546 13.1235C8.92759 11.9423 7.92258 10.9437 6.85003 9.3298C6.36532 8.59955 6.4922 7.65205 7.08645 7.05872L7.6031 6.54207C7.84773 6.29744 7.93262 5.93596 7.82309 5.60826L6.77061 2.44993C6.64647 2.07659 6.29777 1.82556 5.90526 1.82556H2.65656ZM0.0130297 2.82607C-0.1458 1.225 1.17139 0 2.65654 0H5.90524C7.08369 0 8.12977 0.753984 8.5022 1.87218L9.55558 5.03052C9.88328 6.01453 9.6277 7.09987 8.8938 7.83286L8.38536 8.34129C9.3073 9.72512 10.1361 10.5558 11.6678 11.6055L12.1671 11.1062C12.9001 10.3723 13.9855 10.1167 14.9695 10.4444L18.1278 11.4978C19.246 11.8702 20 12.9163 20 14.0948V17.3435C20 18.8286 18.775 20.1458 17.1739 19.987C8.11425 19.0897 0.910326 11.8857 0.0130297 2.82607Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneColored);
export default __webpack_public_path__ + "static/media/PhoneColored.fd211a5aebf427c6ab05f061977138fa.svg";
export { ForwardRef as ReactComponent };